import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "space-y-6 pb-12",
  "data-testid": "region-moves"
}
const _hoisted_2 = {
  key: 0,
  class: "rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-800",
  role: "alert",
  "data-testid": "load-error"
}
const _hoisted_3 = { class: "flex flex-wrap gap-4" }
const _hoisted_4 = { class: "flex-1 min-w-[260px] rounded-xl border border-gray-200 bg-white p-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500" }, "Signed in to", -1)
const _hoisted_6 = {
  class: "mt-1 text-lg font-semibold text-gray-900",
  "data-testid": "current-region"
}
const _hoisted_7 = { class: "mt-1 text-sm text-gray-600" }
const _hoisted_8 = { class: "mt-1 text-sm text-gray-800" }
const _hoisted_9 = {
  key: 0,
  class: "mt-1 text-sm font-medium text-amber-900"
}
const _hoisted_10 = {
  key: 1,
  class: "rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800",
  role: "alert"
}
const _hoisted_11 = { class: "rounded-xl border border-gray-200 bg-white" }
const _hoisted_12 = { class: "flex items-center justify-between border-b border-gray-100 px-4 py-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold text-gray-900" }, "Schools that belong in another region", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "By the country on the school. Pick the ones to move together.", -1)
const _hoisted_15 = {
  class: "mt-1 text-sm text-gray-500",
  "data-testid": "leftover-check"
}
const _hoisted_16 = { class: "text-red-700" }
const _hoisted_17 = { class: "flex flex-wrap gap-2" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "px-4 pt-3 text-sm text-amber-800"
}
const _hoisted_21 = {
  key: 1,
  class: "px-4 pt-3 text-sm text-amber-800"
}
const _hoisted_22 = {
  key: 2,
  class: "px-4 pt-3 text-sm text-amber-800",
  "data-testid": "not-held"
}
const _hoisted_23 = {
  key: 3,
  class: "mx-4 mt-3 rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900",
  "data-testid": "mark-confirm"
}
const _hoisted_24 = { class: "font-semibold" }
const _hoisted_25 = { class: "mt-1" }
const _hoisted_26 = {
  key: 0,
  class: "mt-1 font-medium"
}
const _hoisted_27 = { class: "mt-3 flex gap-3" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 4,
  class: "px-4 py-6 text-sm text-gray-500"
}
const _hoisted_30 = {
  key: 5,
  class: "px-4 py-6 text-sm text-gray-500"
}
const _hoisted_31 = {
  key: 6,
  class: "max-h-80 overflow-y-auto"
}
const _hoisted_32 = { class: "w-full text-left text-sm" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky top-0 bg-gray-50 text-xs uppercase tracking-wide text-gray-500" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-10 px-4 py-2" }),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "School"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Group"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Country"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Belongs in"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Already there"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2 text-right" }, "Learners only here"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Created")
  ])
], -1)
const _hoisted_34 = { class: "px-4 py-2" }
const _hoisted_35 = ["value", "aria-label"]
const _hoisted_36 = { class: "px-4 py-2 font-medium text-gray-900" }
const _hoisted_37 = { class: "px-4 py-2 text-gray-600" }
const _hoisted_38 = { class: "px-4 py-2 text-gray-600" }
const _hoisted_39 = { class: "px-4 py-2 text-gray-900" }
const _hoisted_40 = ["data-testid"]
const _hoisted_41 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_42 = {
  key: 1,
  class: "inline-flex rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-semibold text-green-800"
}
const _hoisted_43 = {
  key: 2,
  class: "inline-flex rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-semibold text-gray-700"
}
const _hoisted_44 = { class: "px-4 py-2 text-right tabular-nums text-gray-900" }
const _hoisted_45 = { class: "px-4 py-2 text-gray-600 tabular-nums" }
const _hoisted_46 = {
  key: 2,
  class: "rounded-xl border border-gray-200 bg-white",
  "data-testid": "moved-schools"
}
const _hoisted_47 = { class: "flex items-center justify-between border-b border-gray-100 px-4 py-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold text-gray-900" }, "Marked as moved", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Read-only copies of schools that live in another region. Nothing can be added to them here.", -1)
const _hoisted_50 = {
  key: 0,
  class: "mt-1 text-sm text-gray-500"
}
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "max-h-80 overflow-y-auto" }
const _hoisted_53 = { class: "w-full text-left text-sm" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky top-0 bg-gray-50 text-xs uppercase tracking-wide text-gray-500" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-10 px-4 py-2" }),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "School"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Group"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Lives in"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2 text-right" }, "Learners only here"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Marked"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" })
  ])
], -1)
const _hoisted_55 = { class: "px-4 py-2" }
const _hoisted_56 = ["value", "aria-label"]
const _hoisted_57 = { class: "px-4 py-2 font-medium text-gray-900" }
const _hoisted_58 = { class: "px-4 py-2 text-gray-600" }
const _hoisted_59 = { class: "px-4 py-2 text-gray-900" }
const _hoisted_60 = ["data-testid"]
const _hoisted_61 = { class: "px-4 py-2 text-gray-600" }
const _hoisted_62 = { class: "tabular-nums" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "px-4 py-2 text-right" }
const _hoisted_65 = {
  key: 0,
  class: "inline-flex items-center gap-4"
}
const _hoisted_66 = ["disabled", "onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 1,
  class: "inline-flex items-center gap-3"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-600" }, "Make it editable here again?", -1)
const _hoisted_70 = ["disabled", "onClick"]
const _hoisted_71 = { class: "rounded-xl border border-gray-200 bg-white" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-100 px-4 py-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold text-gray-900" }, "Moves")
], -1)
const _hoisted_73 = {
  key: 0,
  class: "px-4 py-6 text-sm text-gray-500"
}
const _hoisted_74 = {
  key: 1,
  class: "px-4 py-6 text-sm text-gray-500"
}
const _hoisted_75 = {
  key: 2,
  class: "w-full text-left text-sm"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50 text-xs uppercase tracking-wide text-gray-500" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Schools"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Route"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, "Updated"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" })
  ])
], -1)
const _hoisted_77 = { class: "px-4 py-2 font-medium text-gray-900" }
const _hoisted_78 = {
  key: 0,
  class: "ml-1 text-xs font-normal text-gray-500"
}
const _hoisted_79 = { class: "px-4 py-2 text-gray-600" }
const _hoisted_80 = { class: "px-4 py-2" }
const _hoisted_81 = { class: "px-4 py-2 text-gray-600 tabular-nums" }
const _hoisted_82 = { class: "px-4 py-2 text-right" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = {
  key: 3,
  class: "rounded-xl border border-gray-200 bg-white",
  "data-testid": "move-detail"
}
const _hoisted_85 = { class: "flex flex-wrap items-start justify-between gap-4 border-b border-gray-100 px-4 py-4" }
const _hoisted_86 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_87 = { class: "text-sm text-gray-600" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { class: "flex items-center gap-3" }
const _hoisted_91 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_92 = {
  key: 0,
  class: "flex flex-wrap gap-2 px-4 py-4",
  "aria-label": "Move steps"
}
const _hoisted_93 = ["title"]
const _hoisted_94 = { class: "tabular-nums" }
const _hoisted_95 = {
  key: 1,
  class: "px-4 pb-2 text-sm text-gray-700"
}
const _hoisted_96 = {
  key: 2,
  class: "mx-4 mb-4 rounded-lg border border-amber-300 bg-amber-50 p-4",
  role: "alert",
  "data-testid": "stalled"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-amber-900" }, "Nothing is running this move right now", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-amber-900" }, " Its worker restarted part way through. It picks the move up again by itself within a few minutes, from the last step it finished; you can also resume it now. ", -1)
const _hoisted_99 = ["disabled"]
const _hoisted_100 = {
  key: 3,
  class: "mx-4 mb-4 rounded-lg border border-red-200 bg-red-50 p-4",
  role: "alert"
}
const _hoisted_101 = { class: "text-sm font-semibold text-red-900" }
const _hoisted_102 = { class: "mt-1 text-sm text-red-800" }
const _hoisted_103 = { class: "mt-2 text-sm text-red-800" }
const _hoisted_104 = { class: "mt-3 flex gap-3" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = ["disabled"]
const _hoisted_107 = ["disabled"]
const _hoisted_108 = {
  key: 4,
  class: "space-y-4 px-4 pb-4"
}
const _hoisted_109 = { class: "flex flex-wrap gap-3 text-sm" }
const _hoisted_110 = { class: "block text-xs uppercase tracking-wide text-gray-500" }
const _hoisted_111 = { class: "text-base font-semibold text-gray-900 tabular-nums" }
const _hoisted_112 = {
  key: 0,
  class: "rounded-lg border border-gray-200 p-3 text-sm text-gray-800",
  "data-testid": "transfer-plan"
}
const _hoisted_113 = { class: "font-semibold text-gray-900" }
const _hoisted_114 = {
  key: 1,
  class: "rounded-lg border border-gray-200 p-3 text-sm text-gray-800",
  "data-testid": "learner-plan"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-900" }, "Changing school and region", -1)
const _hoisted_116 = {
  key: 2,
  class: "rounded-lg border border-gray-200 p-3 text-sm text-gray-800",
  "data-testid": "learner-plan"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-900" }, "Learners, not schools", -1)
const _hoisted_118 = {
  key: 1,
  class: "block mt-2 font-medium"
}
const _hoisted_119 = {
  key: 3,
  class: "rounded-lg border border-red-200 bg-red-50 p-4",
  "data-testid": "blockers"
}
const _hoisted_120 = { class: "text-sm font-semibold text-red-900" }
const _hoisted_121 = { class: "mt-2 space-y-1 text-sm text-red-800" }
const _hoisted_122 = { class: "font-mono text-xs" }
const _hoisted_123 = {
  key: 0,
  class: "block text-xs text-red-700"
}
const _hoisted_124 = {
  key: 0,
  class: "mt-3 text-sm font-medium text-red-900",
  "data-testid": "school-check-guidance"
}
const _hoisted_125 = {
  key: 4,
  class: "rounded-lg border border-green-200 bg-green-50 p-3 text-sm text-green-900"
}
const _hoisted_126 = {
  key: 5,
  class: "rounded-lg border border-amber-300 bg-amber-50 p-4"
}
const _hoisted_127 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-amber-900" }, "Worth knowing", -1)
const _hoisted_128 = { class: "mt-2 space-y-1 text-sm text-amber-900" }
const _hoisted_129 = { class: "font-mono text-xs" }
const _hoisted_130 = {
  key: 6,
  class: "text-sm"
}
const _hoisted_131 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-900" }, "School groups", -1)
const _hoisted_132 = { class: "mt-1 space-y-1 text-gray-700" }
const _hoisted_133 = {
  key: 7,
  class: "text-sm"
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-900" }, "Admins", -1)
const _hoisted_135 = { class: "text-gray-600" }
const _hoisted_136 = { class: "mt-2 w-full text-left" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("thead", { class: "text-xs uppercase tracking-wide text-gray-500" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-1 pr-4" }, "Admin"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-1 pr-4" }, "Roles"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-1" }, "Lives in")
  ])
], -1)
const _hoisted_138 = { class: "py-1 pr-4" }
const _hoisted_139 = { class: "text-gray-900" }
const _hoisted_140 = { class: "block text-xs text-gray-500" }
const _hoisted_141 = { class: "py-1 pr-4 text-gray-700" }
const _hoisted_142 = {
  key: 0,
  class: "mt-1 text-xs"
}
const _hoisted_143 = { key: 0 }
const _hoisted_144 = {
  key: 1,
  class: "block text-xs text-red-700"
}
const _hoisted_145 = { class: "py-1" }
const _hoisted_146 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_147 = { value: "source" }
const _hoisted_148 = { value: "destination" }
const _hoisted_149 = {
  key: 1,
  class: "text-gray-900"
}
const _hoisted_150 = {
  key: 2,
  class: "mt-2 flex items-start gap-2 text-sm text-gray-800"
}
const _hoisted_151 = ["value", "data-testid"]
const _hoisted_152 = {
  key: 3,
  class: "block text-xs text-gray-600"
}
const _hoisted_153 = ["disabled"]
const _hoisted_154 = {
  key: 8,
  class: "rounded-lg border border-gray-200 p-4",
  "data-testid": "approve"
}
const _hoisted_155 = {
  class: "block text-sm font-semibold text-gray-900",
  for: "confirm-move"
}
const _hoisted_156 = { class: "font-mono" }
const _hoisted_157 = { class: "mt-2 flex flex-wrap gap-3" }
const _hoisted_158 = ["disabled"]
const _hoisted_159 = ["disabled"]
const _hoisted_160 = ["disabled"]
const _hoisted_161 = {
  key: 5,
  class: "px-4 pb-4 text-sm text-gray-700"
}
const _hoisted_162 = {
  key: 6,
  class: "px-4 pb-4 text-sm"
}
const _hoisted_163 = { class: "font-semibold text-gray-900" }
const _hoisted_164 = { class: "mt-1 grid grid-cols-2 gap-x-6 gap-y-1 md:grid-cols-3" }
const _hoisted_165 = { class: "truncate" }
const _hoisted_166 = { class: "tabular-nums" }
const _hoisted_167 = {
  key: 7,
  class: "mx-4 mb-4 rounded-lg border border-gray-200 bg-gray-50 p-3 text-sm text-gray-800",
  "data-testid": "rolled-back"
}
const _hoisted_168 = {
  key: 8,
  class: "space-y-3 px-4 pb-4"
}
const _hoisted_169 = { class: "rounded-lg border border-green-200 bg-green-50 p-3 text-sm text-green-900" }
const _hoisted_170 = {
  key: 0,
  class: "rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900",
  "data-testid": "conflicts"
}
const _hoisted_171 = { class: "font-semibold" }
const _hoisted_172 = {
  key: 1,
  class: "rounded-lg border border-gray-200 p-4"
}
const _hoisted_173 = {
  class: "block text-sm font-semibold text-gray-900",
  for: "confirm-rollback"
}
const _hoisted_174 = { class: "font-mono" }
const _hoisted_175 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_176 = { class: "mt-2 flex flex-wrap gap-3" }
const _hoisted_177 = ["disabled"]
const _hoisted_178 = {
  key: 9,
  class: "px-4 pb-4 text-sm text-gray-700"
}
const _hoisted_179 = { class: "border-t border-gray-100 px-4 py-3 text-sm" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("summary", { class: "cursor-pointer font-semibold text-gray-900" }, "History", -1)
const _hoisted_181 = { class: "mt-2 space-y-1 text-gray-700" }
const _hoisted_182 = { class: "text-gray-900" }
const _hoisted_183 = { key: 0 }
const _hoisted_184 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_185 = {
  key: 2,
  class: "text-red-700"
}
const _hoisted_186 = {
  key: 3,
  class: "text-gray-500"
}

import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRegionMoveStore, MoveStatus, MovedSchool } from "@/stores/regionMoveStore";
import SchoolChangeComponent from "./SchoolChangeComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegionMoveComponent',
  setup(__props, { expose: __expose }) {

const store = useRegionMoveStore();
const selected = ref<string[]>([]);
const selectedMoved = ref<string[]>([]);
const markConfirm = ref(false);
const unmarking = ref<string | null>(null);
const confirmText = ref("");
const rollbackText = ref("");
const decisions = ref<Record<string, "source" | "destination">>({});
const reuseAdminIds = ref<string[]>([]);
const now = ref(new Date());
let pollTimer: ReturnType<typeof setInterval> | null = null;
let clockTimer: ReturnType<typeof setInterval> | null = null;

const REGION_LABELS: Record<string, string> = { eu: "EU", au: "AU" };
const regionLabel = (code?: string | null) => (code ? REGION_LABELS[code] || code.toUpperCase() : "");

const STEPS = [
  { key: "preflight", label: "Preflight", detail: "Read-only checks", statuses: ["draft", "preflighting", "preflighted"] },
  { key: "approve", label: "Approve", detail: "Typed confirmation", statuses: ["approved"] },
  { key: "copy", label: "Copy", detail: "Everything except users and admins", statuses: ["copying"] },
  { key: "verify", label: "Verify", detail: "Counts and hashes match", statuses: ["verifying"] },
  { key: "cutover", label: "Cutover", detail: "Users and admins land; the directory now answers the new region", statuses: ["cutting_over"] },
  { key: "hold", label: "Hold", detail: "Outlasts the 5 minute directory cache", statuses: ["holding"] },
  { key: "seal", label: "Seal", detail: "Old sessions sign out", statuses: ["sealing"] },
  { key: "delta", label: "Catch up", detail: "Writes made during the move are applied", statuses: ["reconciling"] },
  { key: "quarantine", label: "Park old copy", detail: "Kept 30 days for rollback", statuses: ["quarantining"] },
  { key: "cleanup", label: "Done", detail: "Caches cleared", statuses: ["cleaning", "completed"] }
];
const PHASE_STEP: Record<string, string> = { start: "copy", copy: "copy", verify: "verify", cutover: "cutover", hold: "hold", seal: "seal", delta: "delta", quarantine: "quarantine", cleanup: "cleanup", done: "cleanup", finish: "cleanup", transfer: "copy", preflight: "preflight" };
const PHASE_LABELS: Record<string, string> = { start: "the start checks", preflight: "preflight", copy: "the copy", verify: "verification", cutover: "cutover", hold: "the hold", seal: "the seal", delta: "the catch-up", quarantine: "parking the old copy", cleanup: "clean-up", done: "finishing", finish: "finishing", transfer: "the school change" };
const STATUS_LABELS: Record<string, string> = {
  draft: "Checking",
  preflighting: "Checking",
  preflighted: "Ready to approve",
  approved: "Starting",
  copying: "Copying",
  verifying: "Verifying",
  cutting_over: "Cutting over",
  holding: "Holding",
  sealing: "Sealing",
  reconciling: "Catching up",
  quarantining: "Parking old copy",
  cleaning: "Finishing",
  completed: "Completed",
  failed: "Stopped",
  aborting: "Aborting",
  aborted: "Aborted",
  rolling_back: "Rolling back",
  rolled_back: "Rolled back"
};
const RUNNING: MoveStatus[] = ["draft", "preflighting", "approved", "copying", "verifying", "cutting_over", "holding", "sealing", "reconciling", "quarantining", "cleaning", "aborting", "rolling_back"];

const statusLabel = (status: string, blockers?: number | null) => status === "preflighted" && blockers ? "Blocked" : STATUS_LABELS[status] || status;
const phaseLabel = (phase?: string | null) => (phase ? PHASE_LABELS[phase] || phase : "");
const adminKindLabel = (kind: string) => {
  const learners = !!move.value?.report?.learnerPlan;
  const labels: Record<string, string> = learners
    ? { move: "Only classes that move", spanning: "On both sides", internal: "Internal admin", stay: "Only what stays" }
    : { move: "Only in moving schools", spanning: "On both sides", internal: "Internal admin", stay: "Only in staying schools" };
  return labels[kind] || kind;
};

function pillClass(status: string, blockers?: number | null) {
  const base = "inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold";
  if (status === "completed" || status === "rolled_back") return `${base} bg-green-100 text-green-800`;
  if (status === "failed" || (status === "preflighted" && blockers)) return `${base} bg-red-100 text-red-800`;
  if (status === "preflighted") return `${base} bg-blue-100 text-blue-800`;
  if (status === "aborted") return `${base} bg-gray-100 text-gray-700`;
  return `${base} bg-amber-100 text-amber-900`;
}

const move = computed(() => store.current);
// Refresh while anything on the page is still moving, opened or not.
const polling = computed(
  () => (!!move.value && RUNNING.includes(move.value.status)) || store.moves.some(m => RUNNING.includes(m.status))
);
const editable = computed(() => !!move.value && move.value.status === "preflighted");
const canApprove = computed(
  () => !!move.value && move.value.status === "preflighted" && !!move.value.report && !move.value.report.blockers.length && !decisionsChanged.value && confirmText.value.trim() === move.value.confirmName && !store.acting
);
const canAbort = computed(() => {
  const m = move.value;
  if (!m || m.cutoverStartedAt) return false;
  return m.status === "failed" ? ["start", "copy", "verify", "preflight"].includes(m.failedPhase || "") : ["draft", "preflighted"].includes(m.status);
});
const conflictCount = computed(() => {
  const c = move.value?.conflicts;
  return typeof c === "number" ? c : c?.count || 0;
});

const currentStepIndex = computed(() => {
  const m = move.value;
  if (!m) return -1;
  if (m.status === "failed") return STEPS.findIndex(s => s.key === PHASE_STEP[m.failedPhase || "preflight"]);
  return STEPS.findIndex(s => s.statuses.includes(m.status));
});
function stepClass(index: number) {
  const current = currentStepIndex.value;
  const m = move.value;
  if (m && m.status === "failed" && index === current) return "border-red-300 bg-red-50 text-red-800";
  // A move being rolled back, or rolled back, had finished every step first.
  if (m && ["completed", "rolling_back", "rolled_back"].includes(m.status)) return "border-green-200 bg-green-50 text-green-800";
  if (index < current) return "border-green-200 bg-green-50 text-green-800";
  if (index === current) return "border-blue-400 bg-blue-50 font-semibold text-blue-800";
  return "border-gray-200 text-gray-500";
}

const progressRows = computed(() => {
  const progress = move.value?.progress || {};
  const rows: Array<{ key: string; label: string; docs: number; done: boolean }> = [];
  for (const phase of ["copy", "cutover"]) {
    for (const [collection, entry] of Object.entries(progress[phase] || {})) {
      if (!entry || !entry.docs) continue;
      rows.push({ key: `${phase}.${collection}`, label: collection, docs: entry.docs, done: !!entry.done });
    }
  }
  return rows;
});

const decisionsChanged = computed(() => {
  const saved = move.value?.adminDecisions || {};
  return Object.entries(decisions.value).some(([uid, value]) => (saved[uid] || "source") !== value) ||
    JSON.stringify([...reuseAdminIds.value].sort()) !== JSON.stringify([...(move.value?.reuseAdminIds || [])].sort());
});
const adminAction = (id: string) => move.value?.report?.adminActions?.find(action => action.id === id);
const schoolCheckNeedsLearners = computed(() => move.value?.kind !== "learners" && move.value?.report?.blockers.some(finding => ["SCHOOL_MARKED_MOVED", "SCHOOL_ALREADY_AT_DESTINATION"].includes(finding.code)));
const selectedAlreadyThere = computed(() => selected.value.length > 0 && selected.value.every(id => store.leftovers[id]?.there));
const mixedSchoolMode = computed(() => selected.value.some(id => store.leftovers[id]?.there) && !selectedAlreadyThere.value);

const selectedDestination = computed(() => {
  const destinations = [...new Set(store.mismatches.filter(s => selected.value.includes(s._id)).map(s => s.belongs))];
  return destinations.length === 1 ? destinations[0] : "";
});

/** Schools here the other region already holds: leftover copies, ready to mark. */
const heldThere = computed(() => store.mismatches.filter(s => store.leftovers[s._id]?.there));
function selectHeldThere() {
  selected.value = heldThere.value.map(s => s._id);
}
const notHeldNote = computed(() => {
  const missing = store.mismatches.filter(s => selected.value.includes(s._id) && store.leftovers[s._id] && !store.leftovers[s._id].there);
  if (!missing.length) return "";
  const names = missing.slice(0, 3).map(s => s.name).join(", ") + (missing.length > 3 ? ` and ${missing.length - 3} more` : "");
  return `${regionLabel(missing[0].belongs)} does not hold ${names}. Move ${missing.length === 1 ? "that school" : "those schools"} instead of marking.`;
});
const selectedStrays = computed(() => selected.value.reduce((sum, id) => sum + (store.leftovers[id]?.learnersOnlyHere || 0), 0));

async function markMoved() {
  const to = selectedDestination.value;
  if (!to) return;
  const result = await store.markMoved(selected.value, to);
  if (result !== null) {
    selected.value = [];
    markConfirm.value = false;
    await refresh();
    await store.fetchLeftovers();
  }
}

/** Marked schools with learners the other region lacks. A school not yet counted is offered too. */
const withStrays = computed(() => store.movedSchools.filter(s => (store.leftovers[s._id]?.learnersOnlyHere || 0) > 0));
function selectWithStrays() {
  selectedMoved.value = withStrays.value.map(s => s._id);
}
const movableSelected = computed(() =>
  store.movedSchools.filter(s => selectedMoved.value.includes(s._id) && store.leftovers[s._id]?.learnersOnlyHere !== 0)
);
const mixedMovedDestination = computed(() => new Set(movableSelected.value.map(s => s.movedTo)).size > 1);

async function moveSelectedLearners() {
  const schools = movableSelected.value;
  if (!schools.length || mixedMovedDestination.value) return;
  const created = await store.createLearnerMove(schools.map(s => s._id), [], schools[0].movedTo);
  if (created) {
    selectedMoved.value = [];
    await open(created._id);
  }
}

async function unmark(id: string) {
  const result = await store.unmarkMoved([id]);
  unmarking.value = null;
  if (result !== null) await refresh();
}

/** How many schools a learner move takes new learners from. */
const planSchools = computed(() => move.value?.request?.schoolIds?.length || 0);

/** "1 class and 2 lists": what a learner move copies but leaves in place too. */
const keptSummary = computed(() => {
  const plan = move.value?.report?.learnerPlan;
  if (!plan) return "";
  const part = (n: number | undefined, one: string, many: string) => (n ? `${n} ${n === 1 ? one : many}` : "");
  return [part(plan.classesKept, "class", "classes"), part(plan.listsKept, "list", "lists")].filter(Boolean).join(" and ");
});

/** The report's counts, without the ones a learner move never has. */
const reportCounts = computed(() => {
  const counts = move.value?.report?.scope.counts || {};
  if (!move.value?.report?.learnerPlan) return counts;
  return Object.fromEntries(Object.entries(counts).filter(([key]) => !["schools", "groups"].includes(key)));
});

async function moveLearners(school: MovedSchool) {
  const created = await store.createLearnerMove([school._id], [], school.movedTo);
  if (created) await open(created._id);
}

const mixedDestination = computed(() => {
  const destinations = new Set(store.mismatches.filter(s => selected.value.includes(s._id)).map(s => s.belongs));
  return destinations.size > 1 ? "These schools belong in different regions; move them separately." : "";
});

const inWindow = computed(() => {
  const hour = now.value.getUTCHours();
  return hour >= 20 && hour < 22;
});
const windowLocal = computed(() => {
  const start = new Date(Date.UTC(2026, 0, 1, 20, 0));
  const end = new Date(Date.UTC(2026, 0, 1, 22, 0));
  const fmt = (d: Date) => d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  return `${fmt(start)} to ${fmt(end)}`;
});

const formatDate = (value?: string | null) => (value ? new Date(value).toLocaleDateString() : "");
const formatDateTime = (value?: string | null) => (value ? new Date(value).toLocaleString() : "");
const formatTime = (value?: string | null) => (value ? new Date(value).toLocaleTimeString() : "");
const idList = (ids: Array<string | { id: string; index?: string }>) =>
  ids.map(entry => (typeof entry === "string" ? entry : `${entry.id}${entry.index ? ` (${entry.index})` : ""}`)).join(", ");

function seedDecisions() {
  const m = move.value;
  const next: Record<string, "source" | "destination"> = {};
  for (const admin of m?.report?.scope.admins || []) {
    if (admin.kind === "spanning") next[admin.id] = (m?.adminDecisions || {})[admin.id] || "source";
  }
  decisions.value = next;
  reuseAdminIds.value = [...(m?.reuseAdminIds || [])];
}

/** True once both lists have come back from the server at least once. */
const loaded = ref(false);
const loadError = ref("");

async function refresh() {
  try {
    await Promise.all([store.fetchMoves(), store.fetchMismatches(), store.fetchMovedSchools()]);
    if (store.current) await store.fetchMove(store.current._id);
    loaded.value = true;
    loadError.value = "";
  } catch {
    // Keep what is on screen and say it may be stale; the next tick tries again.
    loadError.value = loaded.value
      ? "Mission Control lost contact with this region. What is shown may be out of date; it retries every few seconds."
      : "Mission Control could not load the moves for this region. Reload the page to try again.";
  }
}

async function open(id: string | null) {
  if (!id) return;
  confirmText.value = "";
  rollbackText.value = "";
  try {
    await store.fetchMove(id);
  } catch {
    // Also reached straight after creating a move, which then exists: say so
    // instead of leaving a button that silently does nothing.
    store.error = "This move could not be loaded. It is in the list below; open it again in a moment.";
    return;
  }
  seedDecisions();
}

async function startMove() {
  const destination = store.mismatches.find(s => s._id === selected.value[0])?.belongs;
  if (!destination || mixedSchoolMode.value || mixedDestination.value) return;
  const created = selectedAlreadyThere.value ? await store.createLearnerMove(selected.value, [], destination) : await store.create(selected.value, destination);
  if (created) {
    selected.value = [];
    await open(created._id);
  }
}

async function act(fn: () => Promise<unknown>) {
  const result = await fn();
  if (result !== null) await refresh();
}

/** Run an action on the open move, then refresh. */
function onMove(fn: (id: string) => Promise<unknown>) {
  return () => {
    const id = move.value?._id;
    return id ? act(() => fn(id)) : Promise.resolve();
  };
}

const approve = onMove(id => store.approve(id, confirmText.value.trim()));
const rerunPreflight = onMove(id => store.preflight(id));
const resume = onMove(id => store.resume(id));
const abort = onMove(id => store.abort(id));
const rollback = onMove(id => store.rollback(id, rollbackText.value.trim()));
const saveDecisions = onMove(id => store.saveDecisions(id, decisions.value, move.value?.report?.adminActions?.some(action => action.canReuse) ? reuseAdminIds.value.filter(id => !(id in decisions.value) || decisions.value[id] === "destination") : undefined));

// A learner move finishing (or being rolled back) changes who is only here.
watch(
  () => store.moves.filter(m => m.kind === "learners" && ["completed", "rolled_back"].includes(m.status)).length,
  (now, before) => {
    if (before !== undefined && now !== before) void store.fetchLeftovers();
  }
);

watch(
  () => move.value && move.value.report && move.value.report.at,
  () => seedDecisions()
);

onMounted(async () => {
  store.current = null;
  store.loading = true;
  await refresh();
  store.loading = false;
  if (loaded.value) void store.fetchLeftovers();
  pollTimer = setInterval(() => {
    if (polling.value) refresh();
  }, 5000);
  clockTimer = setInterval(() => {
    now.value = new Date();
  }, 60000);
});

onBeforeUnmount(() => {
  if (pollTimer) clearInterval(pollTimer);
  if (clockTimer) clearInterval(clockTimer);
});

__expose({ refresh, open });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loadError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(loadError.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, _toDisplayString(regionLabel(_unref(store).region) || (loaded.value ? "Unknown region" : "Checking...")), 1),
        _createElementVNode("p", _hoisted_7, " Moves start from the region holding the school, so this page moves schools out of " + _toDisplayString(regionLabel(_unref(store).region) || "this region") + ". ", 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex-1 min-w-[260px] rounded-xl border p-4", inWindow.value ? 'border-green-200 bg-green-50' : 'border-amber-300 bg-amber-50']),
        "data-testid": "move-window"
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(["text-xs font-semibold uppercase tracking-wide", inWindow.value ? 'text-green-700' : 'text-amber-800'])
        }, " Move window ", 2),
        _createElementVNode("p", _hoisted_8, " 20:00 to 22:00 UTC (" + _toDisplayString(windowLocal.value) + " your time): no school is in session in either region, and the Australian cluster is already scaled up. ", 1),
        (!inWindow.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, " It is outside the window now. Preflight is safe at any time; run the move itself in the window. "))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (_unref(store).error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(store).error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("p", _hoisted_15, [
            (_unref(store).leftoversChecking)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Asking the other region which of these it already holds...")
                ], 64))
              : (_unref(store).leftoversError)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(store).leftoversError), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ml-2 font-semibold text-blue-600 hover:underline",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).fetchLeftovers()))
                    }, "Check again")
                  ], 64))
                : (heldThere.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(heldThere.value.length) + " of these " + _toDisplayString(heldThere.value.length === 1 ? "is a copy" : "are copies") + " the other region already holds. ", 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ml-2 font-semibold text-blue-600 hover:underline",
                        "data-testid": "select-held",
                        onClick: selectHeldThere
                      }, " Select " + _toDisplayString(heldThere.value.length === 1 ? "it" : `all ${heldThere.value.length}`), 1)
                    ], 64))
                  : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-400",
            disabled: !selected.value.length || _unref(store).acting || !!mixedDestination.value || !!notHeldNote.value,
            "data-testid": "start-mark-moved",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (markConfirm.value = true))
          }, " Mark as already in " + _toDisplayString(selectedDestination.value ? regionLabel(selectedDestination.value) : "the other region"), 9, _hoisted_18),
          _createElementVNode("button", {
            type: "button",
            class: "rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300",
            disabled: !selected.value.length || _unref(store).acting || !!mixedDestination.value || mixedSchoolMode.value,
            "data-testid": "start-preflight",
            onClick: startMove
          }, [
            (selectedAlreadyThere.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Check missing learners")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Check " + _toDisplayString(selected.value.length || "") + " school" + _toDisplayString(selected.value.length === 1 ? "" : "s") + " for a move", 1)
                ], 64))
          ], 8, _hoisted_19)
        ])
      ]),
      (mixedDestination.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(mixedDestination.value), 1))
        : (mixedSchoolMode.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Check schools already there separately from schools that need moving."))
          : (notHeldNote.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(notHeldNote.value), 1))
            : _createCommentVNode("", true),
      (markConfirm.value && selected.value.length && selectedDestination.value && !notHeldNote.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("p", _hoisted_24, " Mark " + _toDisplayString(selected.value.length) + " school" + _toDisplayString(selected.value.length === 1 ? "" : "s") + " as already living in " + _toDisplayString(regionLabel(selectedDestination.value)) + "? ", 1),
            _createElementVNode("p", _hoisted_25, " Only for schools " + _toDisplayString(regionLabel(selectedDestination.value)) + " already holds, such as copies left by the first migration. Nothing is copied. The " + _toDisplayString(regionLabel(_unref(store).region)) + " copy stays as a read-only record: nobody can add learners, classes, staff or uploads to it here, and it leaves the school pickers. Learners added here since the migration still need moving. You can unmark a school later. ", 1),
            (selectedStrays.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(selectedStrays.value) + " learner" + _toDisplayString(selectedStrays.value === 1 ? "" : "s") + " in these schools " + _toDisplayString(selectedStrays.value === 1 ? "is" : "are") + " only here. After marking, move them from the \"Marked as moved\" list. ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "button",
                class: "rounded-lg bg-amber-600 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-700 disabled:bg-gray-300",
                disabled: _unref(store).acting,
                onClick: markMoved
              }, " Mark as moved ", 8, _hoisted_28),
              _createElementVNode("button", {
                type: "button",
                class: "rounded-lg px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-white",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (markConfirm.value = false))
              }, "Cancel")
            ])
          ]))
        : _createCommentVNode("", true),
      (!loaded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Loading schools..."))
        : (!_unref(store).mismatches.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Every school here has a country that belongs in " + _toDisplayString(regionLabel(_unref(store).region) || "this region") + ". ", 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("table", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).mismatches, (school) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: school._id,
                      class: "border-t border-gray-100"
                    }, [
                      _createElementVNode("td", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selected).value = $event)),
                          type: "checkbox",
                          value: school._id,
                          class: "h-4 w-4 rounded border-gray-300",
                          "aria-label": `Select ${school.name}`
                        }, null, 8, _hoisted_35), [
                          [_vModelCheckbox, selected.value]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(school.name), 1),
                      _createElementVNode("td", _hoisted_37, _toDisplayString(school.group ? school.group.name : "No group"), 1),
                      _createElementVNode("td", _hoisted_38, _toDisplayString(school.country), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(regionLabel(school.belongs)), 1),
                      _createElementVNode("td", {
                        class: "px-4 py-2",
                        "data-testid": `held-${school._id}`
                      }, [
                        (!_unref(store).leftovers[school._id])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Unknown"))
                          : (_unref(store).leftovers[school._id].there)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(regionLabel(school.belongs)) + " has a copy ", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_43, "Only here"))
                      ], 8, _hoisted_40),
                      _createElementVNode("td", _hoisted_44, _toDisplayString(_unref(store).leftovers[school._id] ? _unref(store).leftovers[school._id].learnersOnlyHere : ""), 1),
                      _createElementVNode("td", _hoisted_45, _toDisplayString(formatDate(school.createdAt)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
    ]),
    (_unref(store).movedSchools.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", null, [
              _hoisted_48,
              _hoisted_49,
              (withStrays.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                    _createTextVNode(_toDisplayString(withStrays.value.length) + " " + _toDisplayString(withStrays.value.length === 1 ? "has" : "have") + " learners the other region does not. ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ml-2 font-semibold text-blue-600 hover:underline",
                      "data-testid": "select-strays",
                      onClick: selectWithStrays
                    }, " Select " + _toDisplayString(withStrays.value.length === 1 ? "it" : `all ${withStrays.value.length}`), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300",
              disabled: !movableSelected.value.length || _unref(store).acting || mixedMovedDestination.value,
              "data-testid": "move-selected-learners",
              onClick: moveSelectedLearners
            }, " Check moving new learners from " + _toDisplayString(movableSelected.value.length || "") + " school" + _toDisplayString(movableSelected.value.length === 1 ? "" : "s"), 9, _hoisted_51)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("table", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).movedSchools, (school) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: school._id,
                    class: "border-t border-gray-100"
                  }, [
                    _createElementVNode("td", _hoisted_55, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedMoved).value = $event)),
                        type: "checkbox",
                        value: school._id,
                        class: "h-4 w-4 rounded border-gray-300",
                        "aria-label": `Select ${school.name}`
                      }, null, 8, _hoisted_56), [
                        [_vModelCheckbox, selectedMoved.value]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_57, _toDisplayString(school.name), 1),
                    _createElementVNode("td", _hoisted_58, _toDisplayString(school.group ? school.group.name : "No group"), 1),
                    _createElementVNode("td", _hoisted_59, _toDisplayString(regionLabel(school.movedTo)), 1),
                    _createElementVNode("td", {
                      class: "px-4 py-2 text-right tabular-nums text-gray-900",
                      "data-testid": `strays-${school._id}`
                    }, _toDisplayString(_unref(store).leftovers[school._id] ? _unref(store).leftovers[school._id].learnersOnlyHere : ""), 9, _hoisted_60),
                    _createElementVNode("td", _hoisted_61, [
                      _createElementVNode("span", _hoisted_62, _toDisplayString(formatDate(school.movedAt)), 1),
                      (school.movedBy && school.movedBy.email)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, " by " + _toDisplayString(school.movedBy.email), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_64, [
                      (unmarking.value !== school._id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-sm font-semibold text-blue-600 hover:underline disabled:text-gray-400",
                              disabled: _unref(store).acting || _unref(store).leftovers[school._id]?.learnersOnlyHere === 0,
                              onClick: ($event: any) => (moveLearners(school))
                            }, _toDisplayString(_unref(store).leftovers[school._id]?.learnersOnlyHere === 0 ? "No new learners" : "Move learners added here"), 9, _hoisted_66),
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-sm font-semibold text-gray-600 hover:underline",
                              onClick: ($event: any) => (unmarking.value = school._id)
                            }, "Unmark", 8, _hoisted_67)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_68, [
                            _hoisted_69,
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-sm font-semibold text-red-600 hover:underline",
                              disabled: _unref(store).acting,
                              onClick: ($event: any) => (unmark(school._id))
                            }, " Unmark ", 8, _hoisted_70),
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-sm text-gray-600 hover:underline",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (unmarking.value = null))
                            }, "Cancel")
                          ]))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(SchoolChangeComponent, { onOpen: open }),
    _createElementVNode("section", _hoisted_71, [
      _hoisted_72,
      (!loaded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_73, "Loading moves..."))
        : (!_unref(store).moves.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_74, "No moves have been started from here."))
          : (_openBlock(), _createElementBlock("table", _hoisted_75, [
              _hoisted_76,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).moves, (move) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: move._id,
                    class: _normalizeClass(["border-t border-gray-100", _unref(store).current && _unref(store).current._id === move._id ? 'bg-blue-50' : ''])
                  }, [
                    _createElementVNode("td", _hoisted_77, [
                      _createTextVNode(_toDisplayString(move.label) + " ", 1),
                      (move.rollbackOf)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_78, "(rollback)"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_79, _toDisplayString(regionLabel(move.from)) + " to " + _toDisplayString(regionLabel(move.to)), 1),
                    _createElementVNode("td", _hoisted_80, [
                      _createElementVNode("span", {
                        class: _normalizeClass(pillClass(move.status, move.blockers))
                      }, _toDisplayString(statusLabel(move.status, move.blockers)), 3)
                    ]),
                    _createElementVNode("td", _hoisted_81, _toDisplayString(formatDateTime(move.updatedAt)), 1),
                    _createElementVNode("td", _hoisted_82, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-sm font-semibold text-blue-600 hover:underline",
                        onClick: ($event: any) => (open(move._id))
                      }, " Open ", 8, _hoisted_83)
                    ])
                  ], 2))
                }), 128))
              ])
            ]))
    ]),
    (move.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_86, _toDisplayString(move.value.label), 1),
              _createElementVNode("p", _hoisted_87, [
                _createTextVNode(_toDisplayString(regionLabel(move.value.from)) + " to " + _toDisplayString(regionLabel(move.value.to)) + " ", 1),
                (move.value.createdBy)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_88, " · started by " + _toDisplayString(move.value.createdBy.email), 1))
                  : _createCommentVNode("", true),
                (move.value.approvedBy)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_89, " · approved by " + _toDisplayString(move.value.approvedBy.email), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_90, [
              (polling.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_91, "Updating every 5 seconds"))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(pillClass(move.value.status, move.value.report?.blockers.length)),
                "data-testid": "move-status"
              }, _toDisplayString(statusLabel(move.value.status, move.value.report?.blockers.length)), 3)
            ])
          ]),
          (move.value.kind !== 'transfer')
            ? (_openBlock(), _createElementBlock("ol", _hoisted_92, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(STEPS, (step, index) => {
                  return _createElementVNode("li", {
                    key: step.key,
                    class: _normalizeClass(["flex items-center gap-2 rounded-full border px-3 py-1 text-xs", stepClass(index)]),
                    title: step.detail
                  }, [
                    _createElementVNode("span", _hoisted_94, _toDisplayString(index + 1), 1),
                    _createElementVNode("span", null, _toDisplayString(step.label), 1)
                  ], 10, _hoisted_93)
                }), 64))
              ]))
            : _createCommentVNode("", true),
          (move.value.status === 'holding' && move.value.holdUntil)
            ? (_openBlock(), _createElementBlock("p", _hoisted_95, " Holding until " + _toDisplayString(formatTime(move.value.holdUntil)) + " so every directory cache has moved on before the old copy is sealed. ", 1))
            : _createCommentVNode("", true),
          (move.value.stalled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                _hoisted_97,
                _hoisted_98,
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-3 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:bg-gray-300",
                  disabled: _unref(store).acting,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(resume) && _unref(resume)(...args)))
                }, " Resume now ", 8, _hoisted_99)
              ]))
            : _createCommentVNode("", true),
          (move.value.status === 'failed')
            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                _createElementVNode("p", _hoisted_101, "Stopped during " + _toDisplayString(phaseLabel(move.value.failedPhase)), 1),
                _createElementVNode("p", _hoisted_102, _toDisplayString(move.value.error && move.value.error.message), 1),
                _createElementVNode("p", _hoisted_103, [
                  (move.value.failedPhase === 'preflight')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Nothing has been copied. Check again once the cause is fixed, or abort. ")
                      ], 64))
                    : (canAbort.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Nothing is visible to learners yet. Resume once the cause is fixed, or abort to remove everything copied so far. ")
                        ], 64))
                      : (move.value.failedPhase !== 'preflight')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(" Learners are already being served from " + _toDisplayString(regionLabel(move.value.to)) + ", so this move can only go forward. Resume it. ", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_104, [
                  (move.value.failedPhase !== 'preflight')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:bg-gray-300",
                        disabled: _unref(store).acting,
                        "data-testid": "resume",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(resume) && _unref(resume)(...args)))
                      }, " Resume ", 8, _hoisted_105))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:bg-gray-300",
                        disabled: _unref(store).acting,
                        "data-testid": "recheck",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(rerunPreflight) && _unref(rerunPreflight)(...args)))
                      }, " Check again ", 8, _hoisted_106)),
                  (canAbort.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "rounded-lg border border-red-300 bg-white px-4 py-2 text-sm font-semibold text-red-700 hover:bg-red-50 disabled:opacity-50",
                        disabled: _unref(store).acting,
                        "data-testid": "abort",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(abort) && _unref(abort)(...args)))
                      }, " Abort ", 8, _hoisted_107))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (move.value.report)
            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                _createElementVNode("div", _hoisted_109, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportCounts.value, (value, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "rounded-lg bg-gray-50 px-3 py-2"
                    }, [
                      _createElementVNode("span", _hoisted_110, _toDisplayString(key), 1),
                      _createElementVNode("span", _hoisted_111, _toDisplayString(value), 1)
                    ]))
                  }), 128))
                ]),
                (move.value.report.transfer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                      _createElementVNode("p", _hoisted_113, "A school change in " + _toDisplayString(regionLabel(move.value.from)), 1),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(move.value.report.transfer.learners === 1 ? "1 learner joins" : `${move.value.report.transfer.learners} learners join`) + " " + _toDisplayString(move.value.report.transfer.school ? move.value.report.transfer.school.name : "the new school"), 1),
                        (move.value.report.transfer.classes)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" in " + _toDisplayString(move.value.report.transfer.classes) + " class" + _toDisplayString(move.value.report.transfer.classes === 1 ? "" : "es"), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createTextVNode(". Nothing is copied and there is no hold: it happens as soon as you approve, and rolling back puts their old school, classes, teachers and lists back. ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (move.value.report.learnerPlan && move.value.report.learnerPlan.changingSchool)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                      _hoisted_115,
                      _createElementVNode("p", null, _toDisplayString(move.value.report.learnerPlan.moving === 1 ? "1 learner joins" : `${move.value.report.learnerPlan.moving} learners join`) + " a school in " + _toDisplayString(regionLabel(move.value.to)) + ". When the move starts they are re-homed to it here first, then moved with their progress; nothing of their old school goes with them, and its custom lists end. Rolling back moves them back and puts their old school, classes, teachers and lists back. ", 1)
                    ]))
                  : (move.value.report.learnerPlan)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                        _hoisted_117,
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(planSchools.value > 1 ? `The ${planSchools.value} schools stay where they are; ${regionLabel(move.value.to)} already has them.` : `The school stays where it is; ${regionLabel(move.value.to)} already has it.`) + " ", 1),
                          (move.value.report.learnerPlan.alreadyThere)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(move.value.report.learnerPlan.alreadyThere) + " of " + _toDisplayString(planSchools.value > 1 ? "their" : "its") + " " + _toDisplayString(move.value.report.learnerPlan.candidates) + " learners here are in " + _toDisplayString(regionLabel(move.value.to)) + " already and are left alone; ", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(move.value.report.learnerPlan.moving) + " move. ", 1),
                          (move.value.report.learnerPlan.alreadyThere)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_118, _toDisplayString(move.value.report.learnerPlan.alreadyThere) + " existing learner" + _toDisplayString(move.value.report.learnerPlan.alreadyThere === 1 ? " is" : "s are") + " deferred. Their progress in both regions stays unchanged and needs a separate comparison. ", 1))
                            : _createCommentVNode("", true),
                          (move.value.report.learnerPlan.classesCopied)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(move.value.report.learnerPlan.classesCopied === 1 ? "The 1 class" : `The ${move.value.report.learnerPlan.classesCopied} classes`) + " they are in that " + _toDisplayString(regionLabel(move.value.to)) + " lacks " + _toDisplayString(move.value.report.learnerPlan.classesCopied === 1 ? "goes" : "go") + " with them. ", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (move.value.report.learnerPlan.listsCopied)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createTextVNode(" So " + _toDisplayString(move.value.report.learnerPlan.listsCopied === 1 ? "does the 1 custom list" : `do the ${move.value.report.learnerPlan.listsCopied} custom lists`) + " they are assigned that " + _toDisplayString(regionLabel(move.value.to)) + " lacks. ", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (move.value.report.learnerPlan.classesKept || move.value.report.learnerPlan.listsKept)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createTextVNode(" Learners who stay still use " + _toDisplayString(keptSummary.value) + ", so " + _toDisplayString(regionLabel(move.value.from)) + " keeps a copy as well. ", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                (move.value.report.blockers.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                      _createElementVNode("p", _hoisted_120, _toDisplayString(move.value.report.blockers.length) + " blocker" + _toDisplayString(move.value.report.blockers.length === 1 ? "" : "s") + ": the move cannot start until these are resolved ", 1),
                      _createElementVNode("ul", _hoisted_121, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(move.value.report.blockers, (finding, i) => {
                          return (_openBlock(), _createElementBlock("li", { key: i }, [
                            _createElementVNode("span", _hoisted_122, _toDisplayString(finding.code), 1),
                            _createTextVNode(" " + _toDisplayString(finding.message) + " ", 1),
                            (finding.ids && finding.ids.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_123, _toDisplayString(idList(finding.ids)), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      (schoolCheckNeedsLearners.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_124, " This school already exists at the destination. Discard this whole-school check, then check missing learners from the school list. Existing learners and their work need a separate comparison. "))
                        : _createCommentVNode("", true)
                    ]))
                  : (move.value.status === 'preflighted')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_125, " No blockers. "))
                    : _createCommentVNode("", true),
                (move.value.report.warnings.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                      _hoisted_127,
                      _createElementVNode("ul", _hoisted_128, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(move.value.report.warnings, (finding, i) => {
                          return (_openBlock(), _createElementBlock("li", { key: i }, [
                            _createElementVNode("span", _hoisted_129, _toDisplayString(finding.code), 1),
                            _createTextVNode(" " + _toDisplayString(finding.message), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (move.value.report.scope.groups.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                      _hoisted_131,
                      _createElementVNode("ul", _hoisted_132, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(move.value.report.scope.groups, (group) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: group.id
                          }, [
                            _createTextVNode(_toDisplayString(group.name) + ": ", 1),
                            (group.kind === 'move')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("moves whole (" + _toDisplayString(group.schoolsInGroup) + " school" + _toDisplayString(group.schoolsInGroup === 1 ? "" : "s") + ")", 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("splits, " + _toDisplayString(group.schoolsMoving) + " of " + _toDisplayString(group.schoolsInGroup) + " schools move; it will exist in both regions", 1)
                                ], 64))
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (move.value.report.scope.admins.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                      _hoisted_134,
                      _createElementVNode("p", _hoisted_135, " Admins with roles on both sides stay in " + _toDisplayString(regionLabel(move.value.from)) + " unless you move them; internal admins never move. A matching account already in " + _toDisplayString(regionLabel(move.value.to)) + " must be reviewed for reuse. Its profile and existing access are kept. ", 1),
                      _createElementVNode("table", _hoisted_136, [
                        _hoisted_137,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(move.value.report.scope.admins, (admin) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: admin.id,
                              class: "border-t border-gray-100"
                            }, [
                              _createElementVNode("td", _hoisted_138, [
                                _createElementVNode("span", _hoisted_139, _toDisplayString(admin.name || admin.email), 1),
                                _createElementVNode("span", _hoisted_140, _toDisplayString(admin.email), 1)
                              ]),
                              _createElementVNode("td", _hoisted_141, [
                                _createTextVNode(_toDisplayString(adminKindLabel(admin.kind)) + " ", 1),
                                (adminAction(admin.id)?.canReuse)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_142, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adminAction(admin.id)?.addedRoles, (role) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: role.id
                                        }, [
                                          _createTextVNode("Add " + _toDisplayString(role.name), 1),
                                          (role.classes.length)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_143, ": " + _toDisplayString(role.classes.join(", ")), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (adminAction(admin.id)?.reason)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_144, _toDisplayString(adminAction(admin.id)?.reason), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_145, [
                                (admin.kind === 'spanning' && editable.value)
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 0,
                                      "onUpdate:modelValue": ($event: any) => ((decisions.value[admin.id]) = $event),
                                      class: "min-w-[9rem] rounded-md border border-gray-300 py-1 pl-2 pr-8 text-sm",
                                      "aria-label": `Region for ${admin.email}`
                                    }, [
                                      _createElementVNode("option", _hoisted_147, "Stays in " + _toDisplayString(regionLabel(move.value.from)), 1),
                                      _createElementVNode("option", _hoisted_148, "Moves to " + _toDisplayString(regionLabel(move.value.to)), 1)
                                    ], 8, _hoisted_146)), [
                                      [_vModelSelect, decisions.value[admin.id]]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_149, _toDisplayString(admin.lands === "destination" ? regionLabel(move.value.to) : regionLabel(move.value.from)), 1)),
                                (adminAction(admin.id)?.canReuse && editable.value && (admin.kind !== 'spanning' || decisions.value[admin.id] === 'destination'))
                                  ? (_openBlock(), _createElementBlock("label", _hoisted_150, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((reuseAdminIds).value = $event)),
                                        type: "checkbox",
                                        value: admin.id,
                                        "data-testid": `reuse-admin-${admin.id}`,
                                        class: "mt-1 h-4 w-4"
                                      }, null, 8, _hoisted_151), [
                                        [_vModelCheckbox, reuseAdminIds.value]
                                      ]),
                                      _createTextVNode(" Reuse the existing " + _toDisplayString(regionLabel(move.value.to)) + " account and add the access shown ", 1)
                                    ]))
                                  : (adminAction(admin.id)?.action === 'reuse')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_152, "Existing account selected for reuse"))
                                    : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      (editable.value && decisionsChanged.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "mt-2 rounded-lg border border-blue-300 px-3 py-1.5 text-sm font-semibold text-blue-700 hover:bg-blue-50",
                            disabled: _unref(store).acting,
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(saveDecisions) && _unref(saveDecisions)(...args)))
                          }, " Save and check again ", 8, _hoisted_153))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (move.value.status === 'preflighted')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                      _createElementVNode("label", _hoisted_155, [
                        _createTextVNode(" To start the move, type "),
                        _createElementVNode("span", _hoisted_156, _toDisplayString(move.value.confirmName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_157, [
                        _withDirectives(_createElementVNode("input", {
                          id: "confirm-move",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((confirmText).value = $event)),
                          type: "text",
                          autocomplete: "off",
                          class: "min-w-[260px] flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm"
                        }, null, 512), [
                          [_vModelText, confirmText.value]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300",
                          disabled: !canApprove.value,
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(approve) && _unref(approve)(...args)))
                        }, " Start move ", 8, _hoisted_158),
                        _createElementVNode("button", {
                          type: "button",
                          class: "rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50",
                          disabled: _unref(store).acting,
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_unref(rerunPreflight) && _unref(rerunPreflight)(...args)))
                        }, " Check again ", 8, _hoisted_159),
                        _createElementVNode("button", {
                          type: "button",
                          class: "rounded-lg px-4 py-2 text-sm font-semibold text-red-700 hover:bg-red-50",
                          disabled: _unref(store).acting,
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_unref(abort) && _unref(abort)(...args)))
                        }, " Discard ", 8, _hoisted_160)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (move.value.status === 'draft' || move.value.status === 'preflighting')
              ? (_openBlock(), _createElementBlock("div", _hoisted_161, " Checking the schools. Nothing is written anywhere until you approve. "))
              : _createCommentVNode("", true),
          (progressRows.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                _createElementVNode("p", _hoisted_163, _toDisplayString(["completed", "rolling_back", "rolled_back"].includes(move.value.status) ? "Copied" : "Copied so far"), 1),
                _createElementVNode("div", _hoisted_164, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(progressRows.value, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: row.key,
                      class: "flex justify-between gap-2 text-gray-700"
                    }, [
                      _createElementVNode("span", _hoisted_165, _toDisplayString(row.label), 1),
                      _createElementVNode("span", _hoisted_166, _toDisplayString(row.docs) + _toDisplayString(row.done ? "" : "…"), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (move.value.status === 'rolled_back')
            ? (_openBlock(), _createElementBlock("p", _hoisted_167, [
                _createTextVNode(" Rolled back. Everything below has moved back to " + _toDisplayString(regionLabel(move.value.from)) + ", with the work done in " + _toDisplayString(regionLabel(move.value.to)) + " in the meantime; the \"Lives in\" column shows where this move had put each admin. ", 1),
                (move.value.rollbackMoveId)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "font-semibold text-blue-600 hover:underline",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (open(move.value.rollbackMoveId)))
                    }, " Open the rollback "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (move.value.status === 'completed')
            ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                _createElementVNode("p", _hoisted_169, [
                  _createTextVNode(" Completed " + _toDisplayString(formatDateTime(move.value.completedAt)) + ". ", 1),
                  (move.value.kind === 'transfer')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Nothing was copied; their old school, classes, teachers and lists are recorded for a rollback.")
                      ], 64))
                    : (move.value.report && move.value.report.learnerPlan)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" These learners' " + _toDisplayString(regionLabel(move.value.from)) + " copies are parked for 30 days; the school stays as it was. ", 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode("The " + _toDisplayString(regionLabel(move.value.from)) + " copy is parked for 30 days.", 1)
                        ], 64))
                ]),
                (conflictCount.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                      _createElementVNode("p", _hoisted_171, _toDisplayString(conflictCount.value) + " document" + _toDisplayString(conflictCount.value === 1 ? "" : "s") + " changed in both regions during the move", 1),
                      _createElementVNode("p", null, "The " + _toDisplayString(regionLabel(move.value.to)) + " version was kept and both versions were recorded for review.", 1)
                    ]))
                  : _createCommentVNode("", true),
                (!move.value.rollbackOf)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                      _createElementVNode("label", _hoisted_173, [
                        (move.value.kind === 'transfer')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("To undo this school change, type ")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("To move this back to " + _toDisplayString(regionLabel(move.value.from)) + ", type ", 1)
                            ], 64)),
                        _createElementVNode("span", _hoisted_174, _toDisplayString(move.value.confirmName), 1)
                      ]),
                      (move.value.kind !== 'transfer')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_175, "Work done in " + _toDisplayString(regionLabel(move.value.to)) + " since the move comes back with it.", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_176, [
                        _withDirectives(_createElementVNode("input", {
                          id: "confirm-rollback",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((rollbackText).value = $event)),
                          type: "text",
                          autocomplete: "off",
                          class: "min-w-[260px] flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm"
                        }, null, 512), [
                          [_vModelText, rollbackText.value]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "rounded-lg border border-red-300 bg-white px-4 py-2 text-sm font-semibold text-red-700 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50",
                          disabled: rollbackText.value.trim() !== move.value.confirmName || _unref(store).acting,
                          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_unref(rollback) && _unref(rollback)(...args)))
                        }, " Roll back ", 8, _hoisted_177)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (move.value.status === 'rolling_back' && move.value.rollbackMoveId)
            ? (_openBlock(), _createElementBlock("p", _hoisted_178, [
                _createTextVNode(" Rolling back. "),
                _createElementVNode("button", {
                  type: "button",
                  class: "font-semibold text-blue-600 hover:underline",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (open(move.value.rollbackMoveId)))
                }, "Follow the rollback")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("details", _hoisted_179, [
            _hoisted_180,
            _createElementVNode("ul", _hoisted_181, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...move.value.history].reverse(), (entry, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: "tabular-nums"
                }, [
                  _createTextVNode(_toDisplayString(formatDateTime(entry.at)) + " ", 1),
                  _createElementVNode("span", _hoisted_182, _toDisplayString(entry.status ? statusLabel(entry.status) : entry.action), 1),
                  (entry.phase)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_183, " (" + _toDisplayString(phaseLabel(entry.phase)) + ")", 1))
                    : _createCommentVNode("", true),
                  (entry.by && entry.by.email)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_184, " by " + _toDisplayString(entry.by.email), 1))
                    : _createCommentVNode("", true),
                  (entry.error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_185, _toDisplayString(entry.error), 1))
                    : _createCommentVNode("", true),
                  (entry.note)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_186, _toDisplayString(entry.note), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})